import { action } from './utils';

export const INVALIDATE_PARALLEL_CURRICULA = 'INVALIDATE_PARALLEL_CURRICULA';
export const SET_PARALLEL_CURRICULA_SUBJECT_PROJECT_EXISTANCE = 'SET_PARALLEL_CURRICULA_SUBJECT_PROJECT_EXISTANCE';
export const parallelCurriculaActions = {
  setSubjectProjectExistance: (hasSubjectProject: boolean) =>
    action(SET_PARALLEL_CURRICULA_SUBJECT_PROJECT_EXISTANCE, { payload: hasSubjectProject }),
  invalidate: () => action(INVALIDATE_PARALLEL_CURRICULA),
};
